import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import {
  FaUsers,
  FaGlobeAsia,
  FaRupeeSign,
  FaShieldAlt,
  FaHeadset,
  FaHandsHelping,
  FaChartLine,
} from "react-icons/fa";

// ---------- SVG placeholder generator ----------
const svgPlaceholder = (
  width,
  height,
  text,
  bgColor = "#e9ecef",
  textColor = "#6c757d",
) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <rect width="${width}" height="${height}" fill="${bgColor}" />
      <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="${Math.min(width, height) / 5}" fill="${textColor}" text-anchor="middle" dy=".3em">${text}</text>
    </svg>
  `;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

const AboutUs = () => {
  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="about-page">
        <Helmet>
          <title>About Us - Panmitra Online Service Pvt. Ltd.</title>
          <meta
            name="description"
            content="Learn about Panmitra Online Service Pvt. Ltd. – a leading fintech company offering PAN card services, mobile/DTH recharge, bill payments, motor insurance, and API solutions for agents and distributors."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>About Panmitra</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>About Panmitra</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*===== HERO AREA ENDS =======*/}
          {/*===== ABOUT AREA STARTS =======*/}
          <div className="about1-section-area sp6 bg-white">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="about-content-area heading2">
                    <h5 className="subtitle">About Panmitra</h5>
                    <h2>Empowering India with Digital Financial Solutions.</h2>
                    <p>
                      Panmitra Online Service Pvt. Ltd. is a trusted fintech
                      company dedicated to making essential financial services
                      accessible to everyone. From instant PAN card processing
                      (NSDL/UTI) to seamless mobile/DTH recharge, utility bill
                      payments, motor insurance (POSP), and powerful API
                      solutions, we provide a robust platform for individuals,
                      agents, and businesses alike.
                    </p>
                    <p className="mt-3">
                      Since our inception in 2020, we have grown to serve over
                      100K agents and processed more than 100 CR transactions
                      across India. Our commitment to reliability, transparency,
                      and innovation has made us a trusted partner for NSDL,
                      UTI, and leading utility providers.
                    </p>
                    <div className="row mt-4">
                      <div className="col-6">
                        <div className="stat-box">
                          <h3 className="fw-bold text-primary">100K+</h3>
                          <p>Active Agents</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="stat-box">
                          <h3 className="fw-bold text-primary">5K+</h3>
                          <p>Active Partners</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img
                    src="/images/about-inner-2.jpg"
                    alt="Panmitra Team"
                    className="img-fluid rounded-4 shadow-lg"
                  />
                </div>
              </div>
            </div>
          </div>
          {/*===== ABOUT AREA ENDS =======*/}
          <div className="space60" />

          {/*===== SERVICE AREA STARTS =======*/}
          <div className="service2-section-area sp1 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 m-auto">
                  <div className="service2-header heading2 text-center">
                    <h5>Our Mission & Vision</h5>
                    <h2>Driving Financial Inclusion Through Technology</h2>
                    <p>
                      At Panmitra, we believe in leveraging technology to
                      simplify financial services and create opportunities for
                      agents and businesses across India.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-7">
                  <div className="images-content-area">
                    <div className="img1">
                      <img
                        src="assets/img/all-images/service-img1.png"
                        alt=""
                      />
                    </div>
                    <div className="content-area">
                      <h5>Our Vision</h5>
                      <a href="/about-us" className="text">
                        To be India's most trusted and widely adopted digital
                        financial platform.
                      </a>
                      <p>
                        We envision a future where every Indian, regardless of
                        location, has access to essential financial services
                        through a network of empowered agents and seamless
                        technology.
                      </p>
                      {/* <div className="btn-area">
                        <a href="/become-partner" className="header-btn1">
                          Join Our Mission{" "}
                          <span>
                            <i className="fa-solid fa-arrow-right" />
                          </span>
                        </a>
                      </div> */}
                    </div>
                    {/* <div className="arrow-area">
                      <a href="/become-partner">
                        <i className="fa-solid fa-arrow-right" />
                      </a>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="service-all-boxes">
                    <div className="row">
                      <div className="col-lg-12 col-md-6">
                        <div className="service2-auhtor-boxarea">
                          <div className="arrow">
                            <a href="/about-us">
                              <i className="fa-solid fa-arrow-right" />
                            </a>
                          </div>
                          <div className="content-area">
                            <h5>Our Mission</h5>
                            <a href="/about-us">
                              Empower agents and businesses with reliable, fast,
                              and secure digital financial tools.
                            </a>
                            <p>
                              We are committed to providing a platform that
                              enables agents to offer PAN card services,
                              recharges, bill payments, and insurance – all in
                              one place.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-6">
                        <div className="service2-auhtor2-boxarea">
                          <div className="arrow">
                            <a href="/about-us">
                              <i className="fa-solid fa-arrow-right" />
                            </a>
                          </div>
                          <div className="content-area">
                            <h5>Our Values</h5>
                            <a href="/about-us">
                              Trust, Transparency, Technology, and Teamwork.
                            </a>
                            <p>
                              We operate with integrity, ensuring every
                              transaction is secure. We innovate constantly and
                              work as a team to support our partners.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*===== SERVICE AREA ENDS =======*/}

          {/*===== WORK AREA STARTS =======*/}
          {/*===== WHY CHOOSE US AREA STARTS =======*/}
          <div className="works-inner-section-area sp1">
            <div className="container">
              {/* Section Title (Centered) */}
              <div className="row">
                <div className="col-lg-8 m-auto">
                  <div className="works-header-area text-center heading2">
                    <h5>Why Choose Us</h5>
                    <h2>The Panmitra Advantage</h2>
                    <p>
                      With years of experience and a network of 100K+ agents,
                      Panmitra stands out as the preferred partner for digital
                      financial services. Here's why thousands trust us.
                    </p>
                  </div>
                </div>
              </div>

              <div className="row align-items-center pt-4">
                {/* Left Column: Reasons List */}
                <div className="col-lg-7">
                  <div className="works-header-area heading2">
                    <div className="works-content-box">
                      <div className="icons">
                        <img
                          src="assets/img/icons/works-icons7.svg"
                          alt="All Services"
                        />
                      </div>
                      <div className="content">
                        <a href="/services">One Platform – All Services</a>
                        <p>
                          PAN card (NSDL/UTI), mobile/DTH recharge, utility bill
                          payments, motor insurance, and API solutions – all
                          integrated into a single dashboard.
                        </p>
                      </div>
                    </div>
                    <div className="space20" />

                    <div className="works-content-box">
                      <div className="icons">
                        <img
                          src="assets/img/icons/works-icons8.svg"
                          alt="Secure & Reliable"
                        />
                      </div>
                      <div className="content">
                        <a>Secure & Reliable Platform</a>
                        <p>
                          99.9% uptime, bank‑grade encryption, and fully
                          compliant with industry standards. Your data and
                          transactions are always safe.
                        </p>
                      </div>
                    </div>
                    <div className="space20" />

                    <div className="works-content-box">
                      <div className="icons">
                        <img
                          src="assets/img/icons/works-icons9.svg"
                          alt="24/7 Support"
                        />
                      </div>
                      <div className="content">
                        <a>24/7 Dedicated Support</a>
                        <p>
                          Get help anytime via phone, WhatsApp, or ticket
                          system. A dedicated relationship manager for every
                          agent.
                        </p>
                      </div>
                    </div>
                    <div className="space20" />

                    <div className="works-content-box">
                      <div className="icons">
                        <img
                          src="assets/img/icons/works-icons8.svg"
                          alt="Easy Onboarding"
                        />
                      </div>
                      <div className="content">
                        <a>Easy Onboarding</a>
                        <p>
                          Simple KYC, instant ID activation, and no technical
                          skills required. Start your business in minutes.
                        </p>
                      </div>
                    </div>
                    <div className="space20" />

                    <div className="works-content-box">
                      <div className="icons">
                        <img
                          src="assets/img/icons/works-icons9.svg"
                          alt="Powerful APIs"
                        />
                      </div>
                      <div className="content">
                        <a>Powerful APIs</a>
                        <p>
                          Integrate PAN, BBPS, recharge, and insurance APIs
                          seamlessly. Detailed documentation and sandbox
                          environment included.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column: Image Grid (as per original design) */}
                <div className="col-lg-5">
                  <img
                    src="/images/why-choose.jpg"
                    alt="Panmitra Office"
                    className="img-fluid rounded-4 shadow-lg"
                  />
                </div>
              </div>
            </div>
          </div>
          {/*===== WHY CHOOSE US AREA ENDS =======*/}
        </>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default AboutUs;
